import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { ILLUSTRATION_SIZE } from './constants';

/** Reserves layout space while a branch illustration chunk loads. */
export function IllustrationPlaceholder() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box aria-hidden={true} sx={{
      width: ILLUSTRATION_SIZE.width,
      height: ILLUSTRATION_SIZE.height,
      flexShrink: 0
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}